// BucketDetailsTable.jsx
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { TableRow, TableCell, Box, IconButton, Chip, Tooltip } from '@mui/material';
import { RowDataContext, RatePlanRowDataContext, BucketDataProvider, RowStateContext, RestrictionsMainDataContext, RestrictionsStateContext } from '../contexts';
import { RatePlanRestrictions } from './RatePlanRestrictions';
import { useFetchApi } from '../../../../hooks/useFetchApi';
import LevelOneLoader from './LevelOneLoader';
import { ToggleRoomTypeCurrentRec } from './ToggleRoomTypeCurrentRec';
import { sortRoomSummary } from '../functions';
import _ from "lodash";
import bucketData from '../bucket-data.json';
import icons from '../svgIcons';
import moment from 'moment';
import { useSelector } from 'react-redux';
export const renderDefaultRestrictions = (default_restrictions) => {
    const minLOS = default_restrictions?.MinLOS;
    if (minLOS != null && minLOS > 1) {
        return (
            <span className='default-label'>Default Min LOS: {minLOS}</span>
        );
    }

    return null;
    // const restrictions = {
    //     MinLOS: 2,
    //     MaxLOS: 3,
    //     MaxAdvanceBook: null,
    //     MinAdvanceBook: null,
    // };

    // return Object.entries(default_restrictions)
    //     .filter(([_, value]) => value != null && value > 1)
    //     .map(([key, value]) => (
    //         <span key={key} style={{ marginRight: '10px' }}>
    //             Default {key}: {value}
    //         </span>
    //     ));

};
export default React.memo(function BucketDetailsTable({
    // details_open,
    rowIndex,
    // activeIndex,
    selectedRoomTypes,
    // toggleRate,
    date,
    // icons,
    currency_symbol,
    dateObj,
    cellStyle,
    cellStyleHeader
}) {
    const appState = useSelector((state) => state);
    const { current_property_date } = appState?.auth?.profile;
    const { app_state } = appState?.app?.current_state;
    const { plrFeatures, as_of_date } = app_state;

    const restrictionsState = useContext(RestrictionsStateContext);
    const mainData = useContext(RestrictionsMainDataContext);

    const rowData = useContext(RowDataContext);
    const rowState = useContext(RestrictionsStateContext);
    // const rowsState = useContext(RowStateContext);
    // const activeIndex = rowsState.state.activeRow;

    let { buckets, details_open } = rowData.data;
    let hasBucketData = Boolean(buckets?.length);
    // const details_open = rowIndex === activeIndex;

    // const [localBuckets, setLocalBuckets] = useState([]);
    let [expendedDate, setExpendedDate] = useState(date);
    // let [expendedRowIndex, setExpendedRowIndex] = useState(null);

    //Moved into functions file
    // const sortRoomSummary = useCallback((buckets, sortOrder) => {
    //     return buckets.map(bucket => {
    //         if (bucket.rooms_summary) {
    //             bucket.rooms_summary.sort((a, b) => {
    //                 const ai = sortOrder.indexOf(a.room_type_code);
    //                 const bi = sortOrder.indexOf(b.room_type_code);
    //                 return ai - bi;
    //             });
    //         }
    //         // If rate plans exist, sort their rooms_summary as well
    //         if (bucket.rate_plans) {
    //             bucket.rate_plans.forEach((ratePlan, i) => {
    //                 bucket.rate_plans[i].rooms_summary.sort((a, b) => {
    //                     const ai = sortOrder.indexOf(a.room_type_code);
    //                     const bi = sortOrder.indexOf(b.room_type_code);
    //                     return ai - bi;
    //                 });
    //             });
    //         }
    //         // bucket.rooms_summary.sort((a, b) => a.room_type_code.localeCompare(b.room_type_code));
    //         return bucket;
    //     });
    // });

    const {
        isLoading: isSecondLoading,
        isSuccess: isSecondSuccess,
        data: secondData,
        error: secondError,
        refetch: callApi
    } = useFetchApi('getDateRestrictionDetails', { uiHelper: true, stayDate: expendedDate }, 'GET', true, expendedDate);

    useEffect(() => {
        if (isSecondSuccess && restrictionsState.state.activeRow === date) {
            let bucketsDataCopy = (secondData && secondData.data) ? _.cloneDeep(secondData.data) : [];
            if (rowData.data.buckets && secondData.data) {
                // setLocalBuckets(bucketsDataCopy);
                // debugger;
                //Sorting order of room summary data as per selected room types
                sortRoomSummary(bucketsDataCopy, selectedRoomTypes);
                rowData.data.buckets = bucketsDataCopy;
                // mainData.data.forEach(item => {
                //     if (item.details_open && item.date !== date) {
                //         item.details_open = false;
                //     }
                // });
                let mainItemIndex = mainData.data.findIndex(itm => itm.date === date);
                mainData.data[mainItemIndex] = _.cloneDeep(rowData.data);
                // mainData.updateData(mainData.data);
                // rowData.data.buckets = toggleBucketsRecRestriction(rowData.data.buckets);
                rowData.updateRowData({ buckets: bucketsDataCopy });
            }
        }

    }, [isSecondSuccess, secondData, date]);

    const isPastDate = moment(date).endOf('day').isBefore(moment());
    const isPastAsOfDate = moment(as_of_date).isBefore(current_property_date);

    //function onClickHandler(bucketIndex) {
    //rowData.data.buckets[bucketIndex].details_open = !rowData.data.buckets[bucketIndex].details_open;
    //rowData.updateRowData(rowData.data);
    //}

    const renderInactive = () => {
        return (
            <Tooltip title="This product is inactive in PMS" arrow>
                <span className="inactive-text">Inactive</span>
            </Tooltip>
        );
    };



    return (
        <>
            {
                secondError && (
                    <>
                        <TableRow className='level-two-header'>
                            <TableCell className='sell-rate-bucket' colSpan={3} style={{ ...cellStyleHeader }}>
                                {/* <Skeleton variant="rounded" height={18} width={314} /> */}
                            </TableCell>
                            {selectedRoomTypes.map((roomType, index) => (
                                <React.Fragment key={index}>
                                    <TableCell style={cellStyleHeader}>
                                        {/* <Skeleton variant="rounded" height={18} width={53} /> */}
                                    </TableCell>
                                    <TableCell style={cellStyleHeader}>
                                        {(index === 1) ? "API Error Occour" : ""}
                                    </TableCell>
                                    <TableCell style={cellStyleHeader}>
                                        {/* <Skeleton variant="rounded" height={18} width={230} /> */}
                                    </TableCell>
                                </React.Fragment>
                            ))}
                        </TableRow>
                    </>
                )
            }
            {
                isSecondLoading && (
                    <LevelOneLoader
                        selectedRoomTypes={selectedRoomTypes}
                        cellStyleHeader={cellStyleHeader}
                        cellStyle={cellStyle}
                    />
                )
            }
            {/* Header Row */}
            {
                (isSecondSuccess || hasBucketData) && !isSecondLoading && date === rowState.state.activeRow && (
                    <>
                        <TableRow className={`level-two-header openSticky`}>
                            <TableCell className='sell-rate-bucket' colSpan={3} style={cellStyleHeader}>
                                Sell Rate Bucket
                            </TableCell>
                            {selectedRoomTypes?.map((roomType, index) => (
                                <React.Fragment key={index}>
                                    <TableCell style={cellStyleHeader}>Sold</TableCell>
                                    <TableCell style={cellStyleHeader}>Sell Rate ({currency_symbol})</TableCell>
                                    <TableCell style={cellStyleHeader}>
                                        Current Restrictions
                                        {plrFeatures.restrictionsRec && !isPastDate && <ToggleRoomTypeCurrentRec isPastDate={isPastDate} roomType={roomType} buckets={dateObj?.buckets} />}
                                        {/* <Checkbox
                                            icon={icons.unCheckedIcon}
                                            checkedIcon={icons.checkedIcon}
                                            indeterminateIcon={icons.indeterminateIcon}
                                            sx={{ p: 0, ml: '4px', mb: '2px' }}
                                        /> */}
                                    </TableCell>
                                </React.Fragment>
                            ))}
                        </TableRow>

                        {/* Bucket Rows */}
                        {buckets.map((bucket, bucketIndex) => (
                            <BucketDataProvider value={bucket} key={bucket.label + bucketIndex}>
                                {/* Bucket Summary Row */}
                                <TableRow className={`level-two-row ${isPastDate ? ' past-date-row' : ''} ${buckets.length - 1 === bucketIndex && !bucket.details_open ? 'last-row' : ''}`} >
                                    <TableCell className='col-rate-bucket' colSpan={3} style={cellStyle}>
                                        <Box className='rate-bucket-cell'>
                                            {/* <Box sx={{ position: 'relative' }}>
                                                <div className='badge-count'>{bucket.badge_count}</div>
                                                {bucket.label}
                                            </Box> */}
                                            {/* <IconButton
                                                className='toggle-icon'
                                                size='small'
                                                onClick={() => toggleRate(date, bucket.label)}
                                                sx={{ p: 0 }}
                                            >
                                                {bucket.details_open ? icons.arrowUpIcon : icons.arrowDownIcon}
                                            </IconButton> */}
                                            {bucket.curr_user_action === 'recommended_accepted' ? <BucketDetailsToggle bucketIndex={bucketIndex} label={bucket.label} badge_count={bucket.badge_counts.rec_accepted} /> : <BucketDetailsToggle bucketIndex={bucketIndex} label={bucket.label} badge_count={bucket.badge_counts.user_updated} />}
                                        </Box>
                                    </TableCell>

                                    {selectedRoomTypes.map((roomType, index) => {
                                        const roomData = bucket.rooms_summary.find(room => room.room_type_code === roomType);
                                        if (!roomData) {
                                            return (
                                                <>
                                                    <TableCell className='col-no-rate-plan' style={cellStyle} colSpan={3}>
                                                        {/* <Tooltip followCursor title="This Room type is not configured for this Rate Plan">-</Tooltip> */}

                                                    </TableCell>
                                                </>
                                            )
                                        }
                                        return (
                                            <RatePlanRowDataContext.Provider value={bucket} key={`bucket-${index}`}>
                                                <>
                                                    <TableCell className='col-sold' style={cellStyle}>
                                                        {roomData?.sold ?? '-'}
                                                    </TableCell>
                                                    <TableCell className='col-sell-rate' style={cellStyle}>
                                                        {roomData?.sell_rate ?? ''}
                                                    </TableCell>
                                                    {!roomData?.restrictions && <TableCell className='col-cur-restrictions' style={cellStyle}>
                                                        -
                                                    </TableCell>}
                                                    {roomData && roomData.restrictions && (
                                                        <RatePlanRestrictions
                                                            compId={`${bucketIndex}_${roomType}`}
                                                            bucketIndex={bucketIndex}
                                                            roomTypeIndex={index}
                                                            ratePlanCode={bucket.label}
                                                            // recAccepted={bucket.rec_accepted}
                                                            type='bucket'
                                                            data={roomData}
                                                            cellStyle={cellStyle}
                                                            itemCounts={buckets.length}
                                                            roomTypeCounts={selectedRoomTypes.length}
                                                        />
                                                    )}
                                                </>
                                            </RatePlanRowDataContext.Provider>
                                        );
                                    })}
                                </TableRow>

                                {/* Rate Plan Rows */}
                                {bucket.details_open &&
                                    bucket.rate_plans.map((ratePlan, ratPlanIndex) => (
                                        <TableRow key={ratePlan.rate_plan_code}
                                            className={`
                                            level-three-row 
                                            ${isPastDate || isPastAsOfDate ? ' past-date-row' : ''} 
                                            ${buckets.length - 1 === bucketIndex && bucket.rate_plans.length - 1 === ratPlanIndex ? 'last-row' : ''}
                                            ${bucket.rate_plans.length - 1 === ratPlanIndex ? 'bucket-last-rate-plan' : ''}
                                        `}>
                                            <TableCell className='col-rate-plan' colSpan={3} style={cellStyle}>
                                                <Tooltip arrow
                                                    classes={{ 'popperInteractive': 'MuiTooltip-popperInteractive rate-plan-label-tooltip ' }}
                                                    title={ratePlan?.label} placement="bottom-start"

                                                    slotProps={{
                                                        popper: {
                                                            modifiers: [
                                                                {
                                                                    name: 'offset',
                                                                    options: {
                                                                        offset: [0, -8],
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    }}
                                                >
                                                    <Box sx={{ display: 'inline-block', cursor: 'default' }} className='rate-plan-label'>
                                                        {ratePlan?.rate_plan_code}  {renderDefaultRestrictions(ratePlan?.default_restrictions)}
                                                        {/* {ratePlan?.default_min_los > 1 && (
                                                        <span>Default Min LOS: {ratePlan.default_min_los}</span>
                                                    )} */}
                                                    </Box>
                                                </Tooltip>
                                            </TableCell>

                                            {selectedRoomTypes.map((roomTypeCode, index) => {
                                                const roomSummary = buckets[bucketIndex].rate_plans[ratPlanIndex].rooms_summary?.find(
                                                    r => r.room_type_code === roomTypeCode
                                                );
                                                if (!roomSummary) {
                                                    return (
                                                        <>
                                                            <TableCell className='col-no-rate-plan' style={cellStyle} colSpan={3}>
                                                                <Tooltip followCursor title={'"' + roomTypeCode + '" is not configured for "' + ratePlan?.rate_plan_code + '"'}>-</Tooltip>
                                                            </TableCell>
                                                        </>
                                                    )
                                                }
                                                return (
                                                    <RatePlanRowDataContext.Provider value={ratePlan} key={`rate-plan-${index}`}>
                                                        <>
                                                            <TableCell className='col-sold' style={cellStyle}>
                                                                {roomSummary?.sold ?? '-'}
                                                            </TableCell>
                                                            <TableCell className='col-sell-rate' style={cellStyle}>
                                                                {/* {roomSummary?.sell_rate ?? '-'} - {String(ratePlan.is_active)} */}
                                                                {ratePlan?.is_active && roomSummary?.sell_rate ? roomSummary.sell_rate : ''}
                                                            </TableCell>
                                                            {!roomSummary?.restrictions && <TableCell className='col-cur-restrictions' style={cellStyle}>
                                                                -
                                                            </TableCell>}
                                                            {!ratePlan?.is_active && <TableCell className='col-cur-restrictions' style={cellStyle}>
                                                                {renderInactive()}
                                                            </TableCell>}
                                                            {ratePlan?.is_active && roomSummary && roomSummary?.restrictions && (
                                                                <RatePlanRestrictions
                                                                    compId={`${bucketIndex}_${roomTypeCode}`}
                                                                    roomTypeCode={roomTypeCode}
                                                                    bucketIndex={bucketIndex}
                                                                    ratePlanIndex={ratPlanIndex}
                                                                    roomTypeIndex={index}
                                                                    ratePlanCode={ratePlan?.rate_plan_code}
                                                                    recAccepted={bucket.rec_accepted}
                                                                    type='rate_plan'
                                                                    data={roomSummary}
                                                                    cellStyle={cellStyle}
                                                                    itemCounts={bucket.rate_plans.length}
                                                                    roomTypeCounts={selectedRoomTypes.length}
                                                                />
                                                            )}

                                                        </>
                                                    </RatePlanRowDataContext.Provider>
                                                );
                                            })}
                                        </TableRow>
                                    ))}
                            </BucketDataProvider>
                        ))}
                    </>
                )}
        </>
    );
})

const BucketDetailsToggle = ({ bucketIndex, label, badge_count, detailsOpen }) => {
    const mainData = useContext(RestrictionsMainDataContext);
    const rowData = useContext(RowDataContext);
    let indexOfRow = mainData.data.findIndex(item => item.date === rowData.data.date);
    const [detailsOpenStatus, setDetailsOpenStatus] = useState(rowData.data.buckets[bucketIndex].details_open);

    function onClickHandler() {
        const detailOpenStatus = !rowData.data.buckets[bucketIndex].details_open;
        rowData.data.buckets[bucketIndex].details_open = detailOpenStatus;
        setTimeout(() => {
            rowData.updateRowData(rowData.data);
        }, 100);
        
        setDetailsOpenStatus(detailOpenStatus);
    }
    useEffect(() => {
        return () => {
            // Cleanup if needed when component unmounts
            rowData.data.buckets[bucketIndex].details_open = false;
            rowData.data.details_open = false;
            rowData.updateRowData({ details_open: false, buckets: rowData.data.buckets });
            setDetailsOpenStatus(false);
        }
    }, []);

    return (
        <Box onClick={onClickHandler} sx={{ display: "flex", alignItems: "center", gap: "6px", width: "100%" }}>
            <Box sx={{ position: 'relative' }}>
                <div className='badge-count'>{badge_count}</div>
                {label}
            </Box>
            <IconButton
                className={`toggle-icon ${detailsOpenStatus ? 'arrow-up' : 'arrow-down'}`}
                size='small'
                sx={{ p: 0 }}>
                {detailsOpenStatus ? icons.arrowUpIcon : icons.arrowDownIcon}
            </IconButton>
        </Box>
    )
}
